import { ReactNode } from 'react';
import styled from 'styled-components';

type FadeInUpProps = {
  children: ReactNode;
  className?: string;
};

export default function FadeInUp({ children, className }: FadeInUpProps) {
  return <Container className={className}>{children}</Container>;
}

const Container = styled.div`
  animation: fadeInUp 0.6s ease-out;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
